export default __webpack_public_path__ + "static/media/reaper.f8649f78.png";